import { createAction, props } from '@ngrx/store';

export const loadLegalEntitiesLists = createAction(
  '[LegalEntitiesList] Load LegalEntitiesLists',
  props<{ request: { BusinessId: string; SearchParam: string } }>()
);

export const loadLegalEntitiesListsSuccess = createAction(
  '[LegalEntitiesList] Load LegalEntitiesLists Success',
  props<{ response: any }>()
);

export const loadLegalEntitiesListsFailure = createAction(
  '[LegalEntitiesList] Load LegalEntitiesLists Failure',
  props<{ error: Error | any }>()
);

export const clearLegalEntitiesList = createAction('[LegalEntitiesList] Clear LegalEntitiesLists');

export const clearBusinessSelected = createAction('[LegalEntitiesList] clear LegalEntitiesLists ');

export const saveSelectedBusinessId = createAction('[LegalEntitiesList] save businessId', props<{ save: string }>());
